import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText, getPlaceholderUrl } from "../../../../utils";

const Template = () => html`
    <ux-iws-content-header-simple>
        <div slot="image">
            <picture>
                <img
                    class="lazyload"
                    alt="Image with 3:2 aspect ratio for mobile and 4:1 for desktop"
                    src="${getPlaceholderUrl(1920, 1280)}"
                    data-src="mock-assets/images/trumpf-outdoor.jpg"
                />
            </picture>
        </div>
        <h1 slot="headline">${getDummyText(46)}</h1>
        <p slot="text">${getDummyText(300)}</p>
    </ux-iws-content-header-simple>
`;

const decorator = (Story) => {
    return html` <div class="ux-t-container-full">${Story()}</div> `;
};

export default {
    title: "Website/Partial Templates/Content Header Simple (Nimbus)",
    component: "ux-iws-content-header-simple",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
